module.exports = __webpack_public_path__ + "static/media/person-img.6e513bcf.svg";